export default __webpack_public_path__ + "static/media/pera.0b48628d.jpg";